import Transports from './transports';
import { Datadog } from '../datadog';

export default class DatadogTransport implements Transports {
  protected datadog: Datadog;

  constructor(datadog: Datadog) {
    this.datadog = datadog;
  }

  debug(...args): void {
    this.datadog.logger.debug(args.shift(), ...args);
  }

  error(...args): void {
    this.datadog.logger.error(args.shift(), ...args);
  }

  info(...args): void {
    this.datadog.logger.info(args.shift(), ...args);
  }

  warning(...args): void {
    this.datadog.logger.warn(args.shift(), ...args);
  }
}
